import { render } from "./EditSystemUser.vue?vue&type=template&id=4fcfc064&scoped=true"
import script from "./EditSystemUser.vue?vue&type=script&lang=js"
export * from "./EditSystemUser.vue?vue&type=script&lang=js"

import "./system-user.scss?vue&type=style&index=0&id=4fcfc064&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fcfc064"]])

export default __exports__